import { z } from 'zod'

export const SummaryChannelSchema = z.enum(['email', 'slack', 'discord', 'issue_tracker'])
export const SummarySelectionSchema = z.enum(['none', 'email', 'slack', 'issue_tracker'])
const WebhookSchema = z.object({ webhookUrl: z.string().trim().optional().nullable(), webhookUrlSet: z.boolean().optional() })
export const SummaryTrackerSchema = z.object({
  provider: z.enum(['github', 'gitlab', 'linear', 'jira', 'asana']),
  githubRepoUrl: z.string().trim().optional(), gitlabProjectUrl: z.string().trim().optional(),
  linearProjectId: z.string().trim().optional(),
  jiraBaseUrl: z.string().trim().optional(), jiraProjectKey: z.string().trim().optional(),
  jiraEmail: z.string().trim().optional(), jiraIssueType: z.string().trim().optional(),
  asanaProjectUrl: z.string().trim().optional(),
  apiToken: z.string().trim().nullable().optional(), apiTokenSet: z.boolean().optional(),
})
export const SummaryDestinationsSchema = z.object({
  selected: z.union([SummarySelectionSchema, z.array(SummaryChannelSchema)]).optional(),
  email: z.object({ recipients: z.enum(['owner', 'members', 'custom']), addresses: z.array(z.string().trim().email().max(320)).max(100) }).nullable().optional(),
  slack: WebhookSchema.nullable().optional(), discord: WebhookSchema.nullable().optional(),
  issue_tracker: SummaryTrackerSchema.nullable().optional(),
})
// Invalid legacy channels must not hide valid destinations or their saved credentials.
export const StoredSummaryDestinationsSchema = SummaryDestinationsSchema.extend({
  selected: SummaryDestinationsSchema.shape.selected.catch('none'),
  email: SummaryDestinationsSchema.shape.email.catch(null),
  slack: SummaryDestinationsSchema.shape.slack.catch(null),
  discord: SummaryDestinationsSchema.shape.discord.catch(null),
  issue_tracker: SummaryDestinationsSchema.shape.issue_tracker.catch(null),
}).nullable().catch(null)
export type SummaryDestinations = z.infer<typeof SummaryDestinationsSchema>
export const DEFAULT_SUMMARY_DESTINATIONS: SummaryDestinations = { email: { recipients: 'owner', addresses: [] } }
export type SummaryTracker = z.infer<typeof SummaryTrackerSchema>
export type SummaryChannel = z.infer<typeof SummaryChannelSchema>
export function activeSummaryChannels(settings: SummaryDestinations): SummaryChannel[] {
  return SummaryChannelSchema.options.filter(channel => !!settings[channel] && (settings.selected === undefined || (Array.isArray(settings.selected) ? settings.selected.includes(channel) : settings.selected === channel)))
}
export const SummaryDeliverySchema = z.object({
  id: z.string(), day: z.string(), name: z.string(), channel: SummaryChannelSchema,
  status: z.enum(['pending', 'sending', 'sent', 'failed', 'uncertain', 'cancelled']),
  detail: z.string().nullable(), external_url: z.string().url().nullable(),
})
export const ReportDeliveryResponseSchema = z.object({
  email_addresses: z.array(z.string()).default([]), settings: SummaryDestinationsSchema.nullable(), can_edit: z.boolean(), deliveries: z.array(SummaryDeliverySchema),
})
export const ReportDeliveryRequestSchema = z.discriminatedUnion('action', [
  z.object({ action: z.literal('save'), settings: SummaryDestinationsSchema }),
  z.object({ action: z.literal('test'), channel: SummaryChannelSchema, settings: SummaryDestinationsSchema.optional() }),
  z.object({ action: z.literal('retry'), id: z.string().uuid(), acknowledge_duplicate_risk: z.boolean().optional() }),
])
export const ReportDeliveryMutationSchema = z.object({ ok: z.boolean(), detail: z.string().optional() })
